






import { Component } from "vue-property-decorator";
import AbstractScene from "@/components/AbstractScene.vue";
import DogyuunComponent from "@/components/DogyuunComponent.vue";

@Component({
  components: {
    DogyuunComponent,
  },
})
export default class PuncherAppearScene extends AbstractScene {
  timeoutForDone = 1000;
}
